export default __webpack_public_path__ + "static/media/edit-document.f94ab1a6.svg";